import { apiRequest, getResource } from "../api/http";

// Email alerts to the team ("logs" section): settings, history, test.
const BASE = "/api/admin/alerts";

export const getAlerts = () => getResource(BASE, { rethrow: true });
/** { enabled, recipients, rules: { <rule>: { enabled, threshold, hours } } }; rejects with the API message. */
export const updateAlerts = (body) => apiRequest("put", BASE, { data: body, rethrow: true });
/** Checks now and sends a test email: { triggered, sent, error }. */
export const testAlerts = () => apiRequest("post", `${BASE}/test`, { rethrow: true });
